import React from 'react';
import Button from '../../../components/ui/Button';
import { ModalShell } from '../../../components/ui/ModalFrame';
import { MODAL_LAYER } from '../../../constants/modalLayers';
import { MODAL_DIALOG_ACTIONS_END } from '../../../constants/layoutSpacing';

const RevokeLicenseDialog = ({
  isOpen,
  member,
  onCancel,
  onConfirm,
  isConfirming = false,
}) => {
  if (!isOpen || !member) return null;

  return (
    <ModalShell
      zClass={MODAL_LAYER.standard}
      backdropClassName="bg-black/50"
      panelClassName="bg-card rounded-lg max-w-md w-full p-6 shadow-elevation-lg"
    >
      <h2 className="text-lg font-semibold mb-2">Revogar licença</h2>

      <p className="text-sm text-muted-foreground mb-6">
        Você está revogando o acesso do usuário{' '}
        <span className="font-medium">{member.email}</span>.
        Deseja continuar?
      </p>

      <div className={MODAL_DIALOG_ACTIONS_END}>
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          disabled={isConfirming}
        >
          Cancelar
        </Button>

        <Button
          type="button"
          variant="destructive"
          onClick={onConfirm}
          disabled={isConfirming}
        >
          {isConfirming ? 'Processando...' : 'Confirmar revogação'}
        </Button>
      </div>
    </ModalShell>
  );
};

export default RevokeLicenseDialog;
